<template>
	<div class="automation-v2-page page noscroll">
		<loading v-if="loading" />
		<template v-else>
			<div class="round-header" v-if="automation">
				<v-button class="go_back_btn" slim :icon="require('@/assets/img/back_bt_arrow.svg')"
				          label="Back to automations" flat @click="$router.replace(`/automations`)"  />

				<div class="automation-name-group" :class="{'__focused':inputFocused}"
				     v-if="(!automationNameSaved || !localName.length)">
					<input type="text" placeholder="Name your automation here" class=""
					       :ref="'searchInput'+id"
					       @focus="inputFocused=true" @blur="inputFocused=false"
					       v-model="localName">

					<v-button class="_save-btn" slim label="Save changes" :loading="savingActive"
					          @click="saveNameChanges" />
					<v-button class="_cancel-btn" slim border label="Cancel" :loading="savingActive"
					          @click="localName = automation.name || '';automationNameSaved=true" />
				</div>

				<h3 class="automation-name" @click="nameClick()"
				    v-if="(automationNameSaved && localName.length>0)">
					{{localName}}
					<inline-svg  :src="require('@/assets/img/pencil-outline.svg')" />
				</h3>

				<div class="automation-activation-group">
					<v-button slim small flat v-tippy="{theme:'small-black'}" :loading="loading" @click="load()"
					          content="Reload" :icon="require('@/assets/img/reload.svg')" />

					<v-button slim small flat v-tippy="{theme:'small-black'}" :loading="cloning" @click="clone()"
					          content="Clone automation" :icon="require('@/assets/img/copy.svg')" />

					<v-switch :label="automation.is_active ? 'Active' : 'Inactive'" :loading="savingActive"
					          v-model="automation.is_active" :value="automation.is_active" right @change="saveChangesToAPI" />
				</div>
			</div>
			<div class="__work-area noscroll" v-if="automation">
				<workflow :automation="automation" is-global />
			</div>
		</template>
	</div>
</template>

<script>
import VButton from "@/components/base/v-button";
import Workflow from "@/components/workflow-v2/Workflow";
import Loading from "@/components/Loading";
import API from "@/api";
import VSpinner from "@/components/base/v-spinner";
import VSwitch from "@/components/base/v-switch";
let id = 1;
export default {
	name: "global-automation",
	components: {VSwitch, VSpinner, Loading, Workflow, VButton},
	mixins: [API],
	data() {
		return {
			id:++id,
			inputFocused:false,
			automationNameSaved:true,
			loading:false,
			savingActive:false,
			automation:{},
			cloning:false,
			localName:'',
		}
	},
	computed:{
		name(){
			return this.automation.name || ''
		},
		automationId(){
			return parseInt(this.$route.params.id);
		},
	},
	methods:{
		nameClick() {
			this.localName = this.automation.name || '';
			this.automationNameSaved = false;
			this.$nextTick(()=>{
				let i = this.$refs['searchInput'+this.id];
				if (!i) return;
				i.focus();
				i.select();
			})
		},
		async clone(){
			try {
				this.cloning = true;
				let result = await this.api.globalAutomations.create(this.automation.id, this.automation.access_key);
				if (!result || result.error) throw result;
				window.location = `/automations/${result.id}`;
			} catch (e) {
				this.$error(e)
			} finally {
				this.cloning = false;
			}
		},
		saveNameChanges(){
			this.automation.name = this.localName;
			this.saveChangesToAPI();
		},
		async saveChangesToAPI() {
			try {
				this.savingActive = true;
				this.automation.id = this.automationId;

				await this.api.globalAutomations.update(this.automationId, this.automation);

				this.automationNameSaved = true;
			} catch (e) {
				this.$error(e)
			} finally {
				this.savingActive = false;
			}
		},
		async load() {
			try {
				this.loading = true;

				this.automation = await this.api.globalAutomations.get(this.automationId);

				this.localName = this.automation.name || '';
			} catch (e) {

			} finally {
				this.loading = false;
			}
		}
	},
	async created() {
		await this.load()
	}
}
</script>
<style lang="scss">
.automation-v2-page {
	.go_back_btn {
		svg {
			color: $black;
			width: 14px;
			height: 14px;
		}
		svg.icon, svg path {
			fill: $black !important;
		}
	}
	.automation-activation-group {
		.small-btn {
			svg {
				height: 14px;
				width: 14px;
			}
		}
		.switch-container {
			.switch .text_label {
				color: $dark-grey;
			}
			&.checked {
				.switch .text_label {
					color: $blue;
				}
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.automation-v2-page {
	display: flex;
	flex-direction: column;
	position: relative;

	.small-btn {
		border: 1px solid #F2F2F5;
		border-radius: 6px;
		height: 28px;
		width: 28px;
	}
	.automation-activation-group {
		display: flex;
		flex-direction: row;
		gap: 20px;
		margin-left: auto;
		.switch-container {
			margin: 0;
		}
	}
	.round-header {
		position: absolute;
		top: 0;
		right: 10px;
		left: 10px;
		z-index: 3;
		background: white;
		border-radius: 8px;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 5px 15px;
		margin: 5px 10px;
		border: 1px solid $light-grey;
		box-shadow: 0 1px 5px #0000001a;
		.switch_checkbox_item {
			position: relative;
		}
	}
	.automation-name {
		min-width: 100px;
		max-width: 350px;
		margin-right: 30px;
		position: relative;
		flex: 1;
		display: flex;
		flex-direction: row;
		border: 1px dashed $grey;
		border-radius: 5px;
		padding: 4px 10px;
		box-shadow: 0 0 0 black;
		cursor: text;
		font-weight: 600;
		font-size: 15px;
		color: $darker-grey;

		svg {
			height: 18px;
			width: 18px;
			display: none;
			right: 10px;
			position: absolute;
			color: $dark-grey;
		}
		&:hover {
			svg {
				display: block;
			}
			background: $light-blue;
			border: 1px dashed $blue;
			input {
				background: $light-blue;
			}
		}
	}
	.automation-name-group {
		min-width: 100px;
		max-width: 500px;
		margin-right: 30px;
		flex: 1;
		position: relative;
		display: flex;
		flex-direction: row;
		border: 1px dashed $blue;
		border-radius: 5px;
		padding: 3px 10px;
		box-shadow: 0 0 0 black;
		&.__focused {
			input {
				background: $light-blue;
			}
			background: $light-blue;
		}
		input {
			color: $darker-grey;
			font-weight: 600;
			font-size: 15px;
			flex: 1;
			margin-right: 5px;
		}
		._save-btn {
			font-size: 10px;
			padding: 2px 8px;
			line-height: 10px;
			min-height: 22px;
			height: 22px;
		}
		._cancel-btn {
			font-size: 10px;
			padding: 2px 8px;
			line-height: 10px;
			min-height: 22px;
			height: 22px;
			margin-left: 8px;
		}
	}

	.go_back_btn {
		margin-right: 30px;
		padding: 2px 10px 2px 4px !important;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 26px;
		cursor: pointer;
		color: $black !important;
		font-weight: 500;
		font-size: 12px;
		white-space: nowrap;
	}

.__work-area {
	display: flex;
	position: relative;
	width: 100%;
	height: 100%;
}
}
</style>
